/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Tooltip,
  ListItemIcon,
} from "@mui/material";
import "./AppHeader.css";
import Logout from "@mui/icons-material/Logout";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import PeopleIcon from "@mui/icons-material/PeopleOutlineOutlined";

const AppHeader: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [darkMode, setDarkMode] = useState(false);
  const [anchorNl, setAnchorNl] = useState<null | HTMLElement>(null);
  const [userRole, setUserRole] = useState<string | null>(null);
  const [userName, setUserName] = useState<string | null>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    const role = localStorage.getItem("authority");
    setUserRole(role);
  }, []);

  useEffect(() => {
    const name = localStorage.getItem("name");
    setUserName(name);
  }, []);
  const Navigate = useNavigate();
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    localStorage.removeItem("token");
    Navigate("/");
  };
  const notificationopen = Boolean(anchorNl);
  const notificationhandleClose = () => {
    setAnchorNl(null);
  };
  const notificationhandleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorNl(event.currentTarget);
  };
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const isMenuItemActive = (menuItem: string) => {
    return location.pathname === menuItem ? "active" : "";
  };
  const [isHovered, setIsHovered] = useState(false);
  const navigateTodashboard = () => {
    navigate("/iot-dashboard");
  };
  const navigateToFleet = () => {
    navigate("/fleet-distance");
  };
  const navigateToReport = () => {
    navigate("/reports");
  };
  const navigateToGeofence = () => {
    navigate("/geofence");
  };
  const navigateToClientIdVerification = () => {
    navigate("/client-ticket");
  };
  const navigateToHelpTicket = () => {
    navigate("/help-ticket");
  };
  const navigateToKycTicket = () => {
    navigate("/kyc-ticket");
  };
  const navigateToTlDashboard = () => {
    navigate("/tl-dashboard");
  };
  const navigateToChurn = () => {
    navigate("/churn-predictor");
  };
  const renderMenuTabs = () => {
    console.log("Current User Role:", userRole); // Debugging

    if (userRole === "ROLE_CONTROL_UNIT") {
      return (
        <a
          onClick={navigateToChurn}
          className={`cursor-pointer ${isMenuItemActive(
            "/churn-predictor"
          )} mr-2 ml-6`}
        >
          <PeopleIcon fontSize="small" className="mr-1 ml-2" /> DashBoard
        </a>
      );
    } else if (userRole === "ROLE_KYC") {
      return (
        <>
          
          {/* <a
            onClick={navigateToHelpTicket}
            className={`cursor-pointer ${isMenuItemActive(
              "/help-ticket"
            )} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Help Ticket
          </a> */}
          <a
            onClick={navigateToKycTicket}
            className={`cursor-pointer ${isMenuItemActive(
              "/kyc-ticket"
            )} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Kyc Ticket
          </a>
         
        </>
      );
    } else if (userRole === "ROLE_DATA" || userRole === "ROLE_ADMIN") {
      return (
        <>
          <a
            onClick={navigateToTlDashboard}
            className={`cursor-pointer ${isMenuItemActive(
              "/tl-dashboard"
            )} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> TL Dashboard
          </a>
        </>
      );
    }else if (userRole === "ROLE_OPS_USER" || userRole === "ROLE_CITY_HEAD") {
      return (
        <>
        <a
            onClick={navigateToClientIdVerification}
            className={`cursor-pointer ${isMenuItemActive(
              "/client-ticket"
            )} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Client Ticket
          </a>
        </>
      )}
        else {
      return (
        <>
          <a
            onClick={navigateTodashboard}
            className={`cursor-pointer ${isMenuItemActive(
              "/iot-dashboard"
            )} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Fleet
            Dashboard
          </a>
          <a
            onClick={navigateToFleet}
            className={`cursor-pointer ${isMenuItemActive(
              "/fleet-distance"
            )} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Fleet Insights
          </a>
          <a
            onClick={navigateToReport}
            className={`cursor-pointer ${isMenuItemActive(
              "/reports"
            )} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Reports
          </a>
          <a
            onClick={navigateToGeofence}
            className={`cursor-pointer ${isMenuItemActive(
              "/geofence"
            )} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Geofence
          </a>
        </>
      );
    }

    // Optionally, you could leave return null if there are additional roles,
    // but currently, every role is covered in the if/else.
    // return null;
  };

  return (
    <div className="w-full text-sm text-[#455A64] font-rubik font-semibold">
      <AppBar
        position="sticky"
        className="bg-gradient-to-r from-slate-100 to-50"
        style={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #EBEBEB",
          boxShadow: "0px 4px 30px 4px #00000005",
        }}
      >
        <Toolbar className="justify-between">
          <div className="flex items-center ">
            <img
              src={"../../assets/invoice-logo.svg"}
              alt="Logo"
              className="h-8 mr-4"
            />
          </div>

          <div className="flex items-center w-2/5 justify-end">
            {userRole !== "ROLE_KYC" && userRole !== "ROLE_OPS_USER" && (
              <div className="flex items-center justify-end">
                <Box sx={{ flexShrink: 0, ml: 0.75 }}>
                  <Tooltip title="Notification">
                    <IconButton
                      onClick={notificationhandleClick}
                      sx={{ ml: 2 }}
                      aria-controls={
                        notificationopen ? "account-menu" : undefined
                      }
                      aria-haspopup="true"
                      aria-expanded={notificationopen ? "true" : undefined}
                    >
                      <NotificationsOutlinedIcon
                        color="success"
                        fontSize="large"
                      />
                    </IconButton>
                  </Tooltip>

                  <Menu
                    anchorEl={anchorNl}
                    id="account-menu"
                    open={notificationopen}
                    onClose={notificationhandleClose}
                    onClick={notificationhandleClose}
                  >
                    <MenuItem>No Notification alert</MenuItem>
                  </Menu>
                </Box>
              </div>
            )}

            <div className="flex  items-center justify-end">
              <Tooltip title="Account">
                <IconButton
                  onClick={handleClick}
                  size="small"
                  aria-controls={open ? "account-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                >
                  <AccountCircleOutlinedIcon color="success" fontSize="large" />
                </IconButton>
              </Tooltip>
              {/* Menu */}
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
              >
                {/* <MenuItem>
                  <ListItemIcon>
                    <AccountIcon fontSize="small" />
                  </ListItemIcon>
                  Profile
                </MenuItem> */}

                {/* <MenuItem onClick={handleClose}>
                  <ListItemIcon>
                    <Settings fontSize="small" />
                  </ListItemIcon>
                  Settings
                </MenuItem> */}

                <MenuItem onClick={handleLogout}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
              <p className="text-black">{userName || "User"}</p>
            </div>
          </div>
        </Toolbar>
      </AppBar>

      <div
        className="h-30"
        style={{ backgroundColor: "#FFFFFF", border: "0px solid #EBEBEB" }}
      >
        <AppBar position="static" color="inherit">
          <Toolbar className="p-4">{renderMenuTabs()}</Toolbar>
        </AppBar>
      </div>
    </div>
  );
};

export default AppHeader;
